


























































































import { Component, Emit, Prop, Vue, Watch } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";
import Viewpoints from "@/store/modules/Viewpoints";
import Decisions from "@/store/modules/Decisions";
import Choices from "@/store/modules/Choices";
import Modelling from "@/store/modules/Modelling";
import * as rules from '@/rules';

const decisionsModule = getModule(Decisions);
const modellingModule = getModule(Modelling);

@Component({
    components: {
    },
})
export default class PasteOptions extends Vue {

    @Prop({
        type: Boolean,
        default: false,
    })
    dialogProp!: boolean;

    @Prop({
        type: String,
        default: '',
    })
    resource!: string;

    private dialog = false;
    private loading = false;
    private outputDecision = ""

    $refs!: {
        form: HTMLFormElement;
    };

    requiredRule = [rules.REQUIRED];

    get decisionsList() {
        return Object.values(decisionsModule.decisions).filter((dec: any)=> dec.decisionId != decisionsModule.selectedDecisionId).sort((a: any, b: any) => {
            if (a.name === null || a.name === undefined) a.name = '';
            if (b.name === null || b.name === undefined) b.name = '';
            return a.name.localeCompare(b.name);
        });
    }

    get copyFactor() {
        return modellingModule.workingModelFactorResources[this.resource]
    }

    get selectedCopyElement() {
        return modellingModule.copyFactorResource;
    }


    mounted() {
        this.dialog = this.dialogProp;
    }

    @Watch('dialogProp')
    onDialogProp(newVal: any, oldVal: any) {
        this.dialog = this.dialogProp;
        //    this.form = Object.assign({}, this.formOrig);
    }

    @Watch('dialog')
    onDialogChange(newVal: any, oldVal: any) {
        this.outputDecision = '';
        //    this.form = Object.assign({}, this.formOrig);
    }



    private cancel() {
        this.dialog = false;
        this.$refs.form.reset();

    }

    private submit() {
        if (!this.$refs.form.validate()) {
            return;
        }
        this.$emit('decision-paste', {decisionId: this.outputDecision, factor: this.resource})
        this.dialog = false;
        this.outputDecision = '';
    }
}

